import React from "react";
import PropTypes from "prop-types";
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, getParam, Api, CaseModalState, Loader, getSessionId } from '@cloudpremise/portal_core';
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Box from '@mui/material/Box';
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDModal from "@cloudpremise/portal_core/src/themes/mui/components/MDModal";

const FileViewerModal = (props) => {
    const { objectUrl, mimeType } = props;
    let width = "100%";
    let height = "100%";
    if(mimeType.indexOf("video") !== -1){
        width = "1000px";
        height = "666.7px";
    }
    

    return (
        <MDModal
            open={props.open}
            onClose={() => props.onCancel()}
            title={"File Viewer"}
            width="1024px"
            maxWidth="1024px"
        >
            <object data={objectUrl} type={mimeType} width={width} height={height}>
              <p>Your browser does not support viewing this file type.</p>
            </object>
        </MDModal>
    )
};

FileViewerModal.defaultProps = {
    folder: null
}
FileViewerModal.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    open: PropTypes.bool,
    objectUrl: PropTypes.string,
    mimeType: PropTypes.string
};

export default FileViewerModal;